import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { PropTypes as PropTypesMobx } from 'mobx-react';
import styles from './CategoryList.module.scss';
import Bind from 'lodash-decorators/bind';
import Debounce from 'lodash-decorators/debounce';

import { isOnMobile } from 'utils/device-utils';

export default class CategoryList extends Component {
  static propTypes = {
    className: PropTypes.string,
    categories: PropTypesMobx.arrayOrObservableArray,
    onSelect: PropTypes.func
  };

  static defaultProps = {
    className: '',
    categories: []
  };

  constructor(props) {
    super(props);
    this.state = {
      categories: props.categories,
      activeOption: '',
      isMobile: isOnMobile()
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  static getDerivedStateFromProps(props, state) {
    return {
      activeOption: props.activeOption,
      categories: props.categories
    };
  }

  setActive(item) {
    this.setState({
      activeOption: item
    });
  }

  renderDesktopView() {
    const className = this.props;

    const categoryList = this.props.categories.map((item, index) => {
      const isActive =
        item.value.toString() === this.state.activeOption.toString();

      return (
        <li
          key={index}
          onClick={() => {
            this.props.onSelect(item.value);
            this.setActive(item.value);
          }}
          className={styles.CategoryListItem}
        >
          <span
            className={`${styles.CategoryListItemTitle}  ${
              isActive ? styles.Active : ''
            }`}
          >
            {item.text}
          </span>
        </li>
      );
    });

    return (
      <ul className={`${styles.CategoryList} ${className}`}>{categoryList}</ul>
    );
  }

  renderMobileView() {
    const active = this.props.activeOption;

    return (
      <select
        className={styles.Select}
        onChange={this.onSelectMobile}
        defaultValue={active}
      >
        {this.props.categories.map((item, i) => (
          <option value={item.value} key={i}>
            {item.text}
          </option>
        ))}
      </select>
    );
  }

  render() {
    const className = this.props;

    return (
      <div className={className}>
        {this.state.isMobile
          ? this.renderMobileView()
          : this.renderDesktopView()}
      </div>
    );
  }

  @Bind()
  @Debounce(200)
  updateDimensions() {
    this.setState({
      isMobile: isOnMobile()
    });
  }

  @Bind()
  onSelectMobile(e) {
    const active = this.props.categories.find(
      category => category.value.toString() === e.target.value
    );
    this.props.onSelect(active.value);
  }
}



// WEBPACK FOOTER //
// ./src/common/components/CategoryList/CategoryList.js